document.documentElement.classList.add('fonts-loading')

// Use Font Face Observer or native Font Loading API
document.fonts.ready.then(() => {
  document.documentElement.classList.remove('fonts-loading')
  document.documentElement.classList.add('fonts-loaded')
})
